import { Trans } from 'react-i18next';
import { useTheme } from 'styled-components';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { Message, MessageOptions } from '@dreryk/react-components';

import { patientTranslationKeys } from '../translations';

import { PatientUnconfirmedAssociateLink } from './PatientUnconfirmedAssociateLink';

const PATIENT_UNCONFIRMED_INFO_STATUS = 'patientUnconfirmed';
const useOptions = (): MessageOptions<Record<typeof PATIENT_UNCONFIRMED_INFO_STATUS, any>> => {
   const theme = useTheme();
   return {
      [PATIENT_UNCONFIRMED_INFO_STATUS]: {
         color: theme.background,
         backgroundColor: theme.backgroundLighter,
         labelColor: theme.backgroundDarker,
      },
   };
};

type PatientUnconfirmedInfoStatusProps = {
   readonly unconfirmedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>;
};

export const PatientUnconfirmedInfoStatus = (props: PatientUnconfirmedInfoStatusProps): JSX.Element => {
   return (
      <Message
         testId={'patientUnconfirmedInfo'}
         type={PATIENT_UNCONFIRMED_INFO_STATUS}
         options={useOptions()}
         label={
            <Trans
               i18nKey={patientTranslationKeys.unconfirmed.missingIdentityNumberInfo}
               components={{
                  patientAssociateLink: (
                     <PatientUnconfirmedAssociateLink unconfirmedPatient={props.unconfirmedPatient} />
                  ),
               }}
            />
         }
         displayIndicator
         fullWidth
      />
   );
};
